import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DynamicObjectInterface } from '../type';
import type { HeaderModel } from '../type';

const initialState: HeaderModel = {
  isLanguageOpen: false,
  isProfileOpen: false,
  isNotificationOpen: false,
};

const headerSlide = createSlice({
  name: 'header',
  initialState: initialState,
  reducers: {
    setLanguageOpen(state, action: PayloadAction<DynamicObjectInterface>) {
      state.isLanguageOpen = action.payload;

      // Close other
      state.isNotificationOpen = false;
      state.isProfileOpen = false;
    },
    setNotificationOpen(state, action: PayloadAction<DynamicObjectInterface>) {
      state.isNotificationOpen = action.payload;

      // Close other
      state.isLanguageOpen = false;
      state.isProfileOpen = false;
    },
    setProfileOpen(state, action: PayloadAction<DynamicObjectInterface>) {
      state.isProfileOpen = action.payload;

      // Close other
      state.isNotificationOpen = false;
      state.isLanguageOpen = false;
    },
  },
});

export default headerSlide;
